import { Component } from '@verndale/core';

class ColumnCard extends Component {
  maxInitialCards: number;

  constructor(el: HTMLElement) {
    super(el);
    this.maxInitialCards = 6;
    this.setupDefaults();
  }

  setupDefaults() {
    this.dom = {
      cardsContainer: this.el.querySelector<HTMLElement>(
        '.column-card__cards-container'
      ),
      cardsInner: this.el.querySelector<HTMLElement>('.column-card__cards'),
      cta: this.el.querySelector<HTMLElement>('.column-card__cta')
    };

    this.hideCards(this.maxInitialCards);
    this.hideCTA(this.maxInitialCards);
    this.setupContactCardsSpace();
  }

  addListeners() {
    (this.dom?.cta as Node)?.addEventListener(
      'click',
      this.handleCtaClick.bind(this)
    );
  }

  hideCards(maxInitialCards: number) {
    const cards = (
      this.dom?.cardsContainer as HTMLElement
    )?.querySelectorAll<HTMLElement>('.listing-card');

    if (!cards?.length) return;
    cards?.forEach((card, index) => {
      if (maxInitialCards && index + 1 > maxInitialCards)
        card.style.display = 'none';
    });
  }

  hideCTA(maxInitialCards: number | undefined) {
    const cards = (
      this.dom?.cardsContainer as HTMLElement
    )?.querySelectorAll<HTMLElement>('.listing-card');
    if (!cards?.length) return;

    if (maxInitialCards && cards?.length <= maxInitialCards) {
      if (this.dom?.cta) (this.dom?.cta as HTMLElement).style.display = 'none';
    }
  }

  handleCtaClick() {
    const cards = (
      this.dom?.cardsContainer as HTMLElement
    ).querySelectorAll<HTMLElement>('.listing-card');
    if (!cards?.length) return;

    (this.dom?.cta as HTMLElement).style.display = 'none';

    for (const card of cards) {
      card.style.display = 'block';
    }
  }

  setupContactCardsSpace() {
    const cards = this.dom.cardsInner as HTMLElement;
    if (cards?.querySelector('.contact-card')) {
      cards.classList.add('column-card__cards--extra-space');
    }
  }
}

export default ColumnCard;
